(function ($) {

    if ($('.post-navigation__arrow-prev i').length > 0) {
        $('.post-navigation__arrow-prev i').after('<svg width="15" height="27" viewBox="0 0 15 27" fill="none" xmlns="http://www.w3.org/2000/svg" class="svg replaced-svg"><path d="M0.466135 26.5351C0.768924 26.8397 1.18327 27 1.58167 27C1.98008 27 2.39442 26.8397 2.69721 26.5351L14.5378 14.6242C14.8406 14.3196 15 13.9188 15 13.502C15 13.0852 14.8406 12.6844 14.5378 12.3798L2.69721 0.468903C2.0757 -0.156301 1.08765 -0.156301 0.466135 0.468903C-0.155378 1.09411 -0.155378 2.08802 0.466135 2.71323L11.1912 13.502L0.466135 24.2908C-0.139442 24.916 -0.139442 25.9259 0.466135 26.5351Z" fill="#2E2E2D"></path> </svg>');
    }
    if ($('.post-navigation__arrow-next i').length > 0) {
        $('.post-navigation__arrow-next i').after('<svg width="15" height="27" viewBox="0 0 15 27" fill="none" xmlns="http://www.w3.org/2000/svg" class="svg replaced-svg"><path d="M0.466135 26.5351C0.768924 26.8397 1.18327 27 1.58167 27C1.98008 27 2.39442 26.8397 2.69721 26.5351L14.5378 14.6242C14.8406 14.3196 15 13.9188 15 13.502C15 13.0852 14.8406 12.6844 14.5378 12.3798L2.69721 0.468903C2.0757 -0.156301 1.08765 -0.156301 0.466135 0.468903C-0.155378 1.09411 -0.155378 2.08802 0.466135 2.71323L11.1912 13.502L0.466135 24.2908C-0.139442 24.916 -0.139442 25.9259 0.466135 26.5351Z" fill="#2E2E2D"></path> </svg>');
    }
    
    if ($('.elementor-share-buttons--view-icon').length > 0) {
        if ($('.elementor-share-btn_linkedin').length > 0) {
            $('.fab.fa-linkedin').removeClass('fa-linkedin').addClass('fa-linkedin-in')
        }

        if ($('.elementor-share-btn_facebook').length > 0) {
            $('.fab.fa-facebook').removeClass('fa-facebook').addClass('fa-facebook-f')
        }
    }
})(jQuery);


// WEBPACK FOOTER //
// ./resources/assets/js/partials/post-navigation.js